import { AfterViewInit, ChangeDetectorRef, Component, Injector, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { addOrSubtractDays, diffInDays, formatDateTime, toDateTime, verifyDateMajorThan } from 'src/app/utils/luxon.helper';

import { MatDatepicker } from '@angular/material/datepicker';
import { DateTime } from 'luxon';
import { Busca, Cidade, Orcamento, Quarto, TIPOBUSCAAEREO, Trecho } from 'src/app/model';
import { AeroportoService, CidadeService, LoginService, PaisService } from 'src/app/services';
import { ReservaService } from './../../services/turismo/reserva.service';

@Component({
  selector: 'app-busca',
  templateUrl: './busca.component.html',
  styleUrls: ['./busca.component.css'], standalone: false
})
export class BuscaComponent implements OnInit, AfterViewInit {
  protected _router: Router;
  protected route: ActivatedRoute;
  protected cidadeService: CidadeService;
  protected aeroportoService: AeroportoService;
  protected loginService: LoginService;
  protected paisService: PaisService;
  protected modalService: NgbModal;
  protected cdrChange: ChangeDetectorRef;
  protected reservaService: ReservaService;

  @ViewChildren('picker') datepickers!: QueryList<MatDatepicker<Date>>;
  pickers: MatDatepicker<Date>[] = [];

  BUSCA: string = 'busca';
  ORCAMENTO: string = 'orcamentousuario';
  TIMERBUSCA: string = "timerBusca"
  TIPOBUSCAAEREO: typeof TIPOBUSCAAEREO = TIPOBUSCAAEREO;

  // Verificados e revistos;
  busca: Busca = new Busca();
  Orcamento: Orcamento = new Orcamento();
  cidades: Cidade[] = [];
  timerCidade = null;

  usuarioLogado: any = null;

  //CIRCUITO
  Fornecedores: string[] = ["ST"];
  FiltroCircuito: string[] = ["ST"];
  Temporadas: string[] = [];
  Temporada: string;

  constructor(injector: Injector) {
    this._router = injector.get(Router);
    this.route = injector.get(ActivatedRoute);
    this.cidadeService = injector.get(CidadeService);
    this.aeroportoService = injector.get(AeroportoService);
    this.loginService = injector.get(LoginService);
    this.paisService = injector.get(PaisService);
    this.modalService = injector.get(NgbModal);
    this.cdrChange = injector.get(ChangeDetectorRef);
    this.loginService = injector.get(LoginService);
    this.reservaService = injector.get(ReservaService);
    this.usuarioLogado = this.loginService.user();
  }

  // Não verificados
  // buscaValidator: any;
  // rebusca = false;
  // adicionar = false;
  // bloqueado = false;
  // id = null;

  ngOnInit() {
    const id = this.route.snapshot.params.id;
    if (verifyDateMajorThan(new Date(), toDateTime(window.sessionStorage.getItem(this.TIMERBUSCA))) || id !== undefined) {
      const busca = window.sessionStorage.getItem(this.BUSCA);
      const orcamento = window.sessionStorage.getItem(this.ORCAMENTO);
      if (busca !== null) {
        this.busca = this.busca.decodeBuscaNovo(busca);

        this.busca.trechos.forEach((trecho, index) => {
          trecho.dataIda = toDateTime(trecho.dataIda.toString());
          trecho.dataVolta = toDateTime(trecho.dataVolta.toString());
          trecho.minDataVolta = toDateTime(trecho.minDataVolta.toString());
          trecho.minDataIda = toDateTime(new Date());
        });
      }

      if (orcamento) {
        this.Orcamento = JSON.parse(orcamento);
      }
    } else {
      // alert('A busca expirou, por favor refaça a busca.');
      window.sessionStorage.removeItem(this.BUSCA);
      window.sessionStorage.removeItem(this.ORCAMENTO);
      window.sessionStorage.removeItem(this.TIMERBUSCA);
      this._router.navigate(['/']);
    }

    if (id !== undefined) {
      this.busca.ReservaId = id;
      this.busca.novoOrcamento = false;
      this.buscarDadosParaBusca(id);
    } else {
      // Sem id na rota, garantir que não mantenha ReservaId antiga
      this.busca.ReservaId = 0;
      this.busca.novoOrcamento = true;
    }
  }

  ngAfterViewInit() {
    this.datepickers.changes.subscribe(() => {
      this.pickers = this.datepickers.toArray();
    });
  }

  buscar() {
    this.busca.guid = null;
    this.busca.primeira = true;
    this.busca.novoOrcamento = true;
    this.busca.Temporada = this.Temporada;
    this.busca.Fornecedores = this.FiltroCircuito;
    window.sessionStorage.removeItem('buscapacote');

    this.busca.usuario = this.usuarioLogado;
    this.busca.PacoteId = 0;

    if (this.usuarioLogado.AgenciaId) {
      this.busca.AgenciaId = this.usuarioLogado.AgenciaId;
    } else {
      let agencia = localStorage.getItem('g8h7d8');
      if (agencia != null) {
        const agenciaID = JSON.parse(atob(agencia));
        this.busca.AgenciaId = agenciaID.Id;
      }
    }

    window.sessionStorage.removeItem(this.BUSCA);
    window.sessionStorage.setItem(this.BUSCA, JSON.stringify(this.busca));
    window.sessionStorage.removeItem(this.ORCAMENTO);

    const dataParaCancelarBusca = addOrSubtractDays(new Date(), { minute: 60 });
    window.sessionStorage.setItem(this.TIMERBUSCA, dataParaCancelarBusca.toISO());

    if (this.busca.ReservaId > 0) {
      if (this.busca.tipoBusca.aereo) {
        this._router.navigate([`adicionar/${this.busca.ReservaId}/aereo`]);
      } else if (this.busca.tipoBusca.hotel) {
        this._router.navigate([`adicionar/${this.busca.ReservaId}/hotel`]);
      } else if (this.busca.tipoBusca.ticket) {
        this._router.navigate([`adicionar/${this.busca.ReservaId}/servico`]);
      } else if (this.busca.tipoBusca.servicoExclusivo) {
        this._router.navigate([`adicionar/${this.busca.ReservaId}/servicoexclusivos`]);
      } else if (this.busca.tipoBusca.carro) {
        this._router.navigate([`adicionar/${this.busca.ReservaId}/carro`]);
      } else if (this.busca.tipoBusca.beto) {
        this._router.navigate([`adicionar/${this.busca.ReservaId}/beto-carrero`]);
      } else if (this.busca.tipoBusca.circuito) {
        this._router.navigate([`adicionar/${this.busca.ReservaId}/circuito`]);
      }

    } else {

      if (this.busca.tipoBusca.aereo) {
        this._router.navigate([`listas/aereo`]);
      } else if (this.busca.tipoBusca.hotel) {
        this._router.navigate([`listas/hotel`]);
      } else if (this.busca.tipoBusca.ticket) {
        this._router.navigate([`listas/servico`]);
      } else if (this.busca.tipoBusca.servicoExclusivo) {
        this._router.navigate([`listas/servicoexclusivos`]);
      } else if (this.busca.tipoBusca.carro) {
        this._router.navigate([`listas/carro`]);
      } else if (this.busca.tipoBusca.beto) {
        this._router.navigate([`listas/beto-carrero`]);
      } else if (this.busca.tipoBusca.circuito) {
        this._router.navigate([`listas/circuito`]);
      }
    }
  }

  buscaCidade(val: string) {
    if (this.busca.tipoBusca.aereo) {
      this.aeroportoService.buscarPorParametro(val, 1).subscribe(
        dados => {
          '';
          this.cidades = dados.Items.map(x => {
            x.display_field = `${x.Iata} - ${x.Descricao} / ${x.Cidade.Nome} - ${x.Cidade.Estado.Iata} / ${x.Cidade.Estado.Pais.Iata}`;
            return x;
          });
        },
        erro => {
          console.log(erro);
          this.cidades = [];
        }
      );
    } else {
      this.cidadeService.buscarOrcamento(val, 1).subscribe(
        dados => {
          '';
          this.cidades = dados.Items.map(x => {
            x.display_field = x.Nome + ' - ' + x.Estado.Nome + ' / ' + x.Estado.Pais.Nome;
            return x;
          });
        },
        erro => {
          console.log(erro);
          this.cidades = [];
        }
      );
    }
  }

  buscaCidadeDebounce(val: string) {
    clearTimeout(this.timerCidade);
    this.timerCidade = setTimeout(() => {
      this.buscaDados(val);
    }, 600);
  }

  buscaDados(val: string) {
    if (this.busca.tipoBusca.aereo) {
      this.aeroportoService.buscarPorParametro(val, 1).subscribe(
        dados => {
          this.cidades = dados.Items.map(x => {
            x.display_field = `${x.Iata} - ${x.Descricao} / ${x.Cidade.Nome} - ${x.Cidade.Estado.Iata} / ${x.Cidade.Estado.Pais.Iata}`;
            return x;
          });
        },
        erro => {
          console.log(erro);
          this.cidades = [];
        }
      );
    } else {
      this.cidadeService.buscarOrcamento(val, 1).subscribe(
        dados => {
          this.cidades = dados.Items.map(x => {
            x.display_field = x.Nome + ' - ' + x.Estado.Nome + ' / ' + x.Estado.Pais.Nome;
            return x;
          });
        },
        erro => {
          console.log(erro);
          this.cidades = [];
        }
      );
    }
  }

  selecionaCidadeOrigem(item, trecho) {
    if (this.busca.tipoBusca.aereo) {
      trecho.AeroportoPartida = item;
      trecho.cidadeOrigem = item.Cidade;
    } else {
      trecho.cidadeOrigem = item;
    }
  }

  selecionaCidadeDestino(item, trecho) {
    if (this.busca.tipoBusca.aereo) {
      trecho.AeroportoChegada = item;
      trecho.cidadeDestino = item.Cidade;
      trecho.cidadeDestino.display_field =
        trecho.cidadeDestino.Nome +
        ' - ' +
        trecho.cidadeDestino.Estado.Nome +
        ' / ' +
        trecho.cidadeDestino.Estado.Pais.Nome;
    } else {
      trecho.cidadeDestino = item;
    }
  }

  setDataIda(event: any, trechos: Trecho[], indice: number) {
    trechos[indice].dataIda = toDateTime(event.value);

    const dataVolta = addOrSubtractDays(trechos[indice].dataIda, { day: 1 });
    trechos[indice].minDataVolta = dataVolta;
    trechos[indice].dataVolta = dataVolta;

    if (this.busca.tipoBusca.beto) {
      this.busca.dataVisitaBetoCarrero = trechos[indice].dataIda || this.getAmanha();
    }

    this.busca.nrnoites = diffInDays(trechos[indice].dataIda, trechos[indice].dataVolta);

    if (this.busca.tipoBusca.beto)
      this.busca.dataVisitaBetoCarrero = trechos[indice]?.dataIda ? trechos[indice].dataIda : this.getHoje();

    this.cdrChange.detectChanges();
    this.pickers = this.datepickers.toArray();
  }

  setDataVolta(event: any, trechos: Trecho[], indice: number) {
    trechos[indice].dataVolta = toDateTime(event.value);
    this.busca.nrnoites = diffInDays(trechos[indice].dataIda, trechos[indice].dataVolta);
    this.cdrChange.detectChanges();
  }

  buscarDadosParaBusca(id) {
    this.reservaService.buscaReservaBusca(id).subscribe(
      dados => {
        this.busca.AgenciaId = dados.AgenciaId;
        this.busca.quartos = dados.quartos;
        window.sessionStorage.setItem(this.BUSCA, JSON.stringify(this.busca));
      },
      erros => {
        console.log(erros);
        setTimeout(() => {
          this.buscarDadosParaBusca(id);
        }, 2500);
      }
    );
  }

  getAmanha(): DateTime {
    return addOrSubtractDays(new Date(), { day: 1 });
  }

  getHoje(): DateTime {
    return toDateTime(new Date().toISOString());
  }

  addOneYear(year: string): string {
    return (Number.parseInt(year) + 1).toString();
  }

  circuitoSelecionado(circuito) {
    return this.FiltroCircuito.indexOf(circuito) >= 0;
  }
  selecionarCircuito(circuito) {
    if (this.circuitoSelecionado(circuito)) {
        this.FiltroCircuito = this.FiltroCircuito.filter(x => x != circuito);
    } else {
        this.FiltroCircuito.push(circuito);
    }
  } 
}
